/**
 * This file is part of the "box" project.
 *
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
;(function($) {

  /**
   * Update checked checkboxes from storage.
   */
  $.bulkStorageUpdateCheckboxes = function () {
    var storage = $.localStorage,
        data    = storage.isSet('domains_bulk') ? storage.get('domains_bulk') : [];

    // update all checkboxes
    $.each(data, function() {
      $('[data-domain="{0}"]'.format(this)).prop('checked', true);
    });

    // update main bulk checkbox
    if(0  == $('.domain-bulk-op-item:not(:checked)').length && 0 != $('.domain-bulk-op-item:checked').length) {
      $('#domain-bulk-op-select-all').prop('checked', true);
    }
  };

  /**
   * Update bulk control block
   */
  $.bulkStorageUpdateControl = function() {
    var storage     = $.localStorage,
        bulkControl = $('#domain-bulk-control'),
        data        = storage.isSet('domains_bulk') ? storage.get('domains_bulk') : [];

    // update count of selected domains in table head
    0 == data.length ? bulkControl.addClass('hidden') : bulkControl.removeClass('hidden');
    bulkControl.find('span>span').html(data.length);
  };

  /**
   * Clear selected domains.
   */
  $.bulkClearSelectedDomains = function() {
    $.localStorage.set('domains_bulk', []);

    // uncheck checkboxes
    $('.domain-bulk-op-item').prop('checked', false);
    $('#domain-bulk-op-select-all').prop('checked', false);

    // hide control block
    $.bulkStorageUpdateControl();
  };

  /**
   * Get selected domains.
   *
   * @return {Array}
   */
  $.bulkGetSelectedDomains = function() {
    var checkboxes = $('.domain-bulk-op-item:checked'),
        storage    = $.localStorage,
        data       = storage.isSet('domains_bulk') ? storage.get('domains_bulk') : [],
        domains    = [];

    $.each(checkboxes, function() {
      domains.push($(this).data('domain'));
    });

    $.each(data, function() {
      if(-1 == $.inArray(this, domains)) {
        domains.push(this);
      }
    });

    return domains;
  };

  $(document).ready(function(e) {

    // update checkboxes
    $.bulkStorageUpdateCheckboxes();

    // update bulk control block
    $.bulkStorageUpdateControl();

    // clear selected domains
    $('#domain-bulk-control').find('a').click(function(e) {
      $.bulkClearSelectedDomains();

      e.preventDefault();
    });

    // change domains per page
    $('#domains-per-page').change(function () {
      $.pageReload({'domains_qty': $(this).val()});
    });

    // check/uncheck all checkboxes
    $('#domain-bulk-op-select-all').change(function () {
      $('.domain-bulk-op-item').not(':disabled').prop('checked', $(this).prop("checked"));
      $.bulkStorageDomainsUpdate();
    });

    // update bulk control
    $('.domain-bulk-op-item').change(function () {
      $.bulkStorageDomainsUpdate();
    });

    // bulk renew
    $('#domain-bulk-renew-action').click(function(e) {
      var el = $(this);

      el.buttonLoading('loading');

      // get selected domains
      var domains = $.bulkGetSelectedDomains();

      // no domains selected
      if(0 == domains.length) {
        el.buttonLoading('reset');

        $.showError($.translate('Please select domains.'));

        e.preventDefault();
        return;
      }

      // get form
      $.get(el.attr('href'), {domains: domains}, function(response) {
        el.buttonLoading('reset');

        // if user is anonymous
        if(0 == response.status && undefined != response.page) {
          window.location = Storage.getData('app_url') + response.page;

          return;
        }

        // if error message and need to show errors
        if(0 == response.status && undefined != response.message) {
          $.showError(response.message);

          return;
        }

        // show form
        $.fancybox.open({
          type:    'iframe',
          padding: 0,
          content: response.html,
          afterShow: function () {
            // vars
            var form           = $('#renew-domain-bulk-op'),
                years          = form.find('input[type="radio"]'),
                domains        = form.find('#bulk-op-domains-list input[type="checkbox"]'),
                cvvHelp        = form.find('.cvvhelp'),
                cvvHelpImage   = form.find('.cvvhelp img'),
                checkCoupon    = form.find('#checkCoupon'),
                couponCode     = form.find('#couponCode');
                couponError    = form.find('#cpn-error'),
                couponMessage  = form.find('#cpnDis'),
                button         = $('button#renew');

            // tooltips name
            $('.show-tooltip').addTooltip();

            // cvv help image
            cvvHelp.hover(function () {
              cvvHelpImage.show();
            }, function () {
              cvvHelpImage.hide();
            });

            // update price
            years.change(function() {
              $.bulkOpUpdatePrice(form, years, domains);
            });

            domains.change(function() {
              $.bulkOpUpdatePrice(form, years, domains);
            });

            $.bulkUpdateYearlyPrices();

            // check coupon
            couponCode.on('keyup change', function() {
              var el = $(this), state = false;

              if('' == el.val() || 0 == years.filter(':checked').length || 0 == domains.filter(':checked').length) {
                state = true;
              }

              checkCoupon.prop('disabled', state);
            });

            checkCoupon.click(function (e) {
              var code = $('#couponCode').val();
              checkCoupon.buttonLoading('loading');

              $.get(Storage.getData('app_url') + 'checkCpn/' + code, '', function (response) {
                $.bulkOpUpdatePrice(form, years, domains, parseFloat(response));

                checkCoupon.button('reset');
              });
            });

            // submit form
            var bulkRenewSubmitting = false;
            form.on('submit', function() {
              e.preventDefault();
              if (bulkRenewSubmitting) return false;
              button.buttonLoading('loading');

              // validate form
              var errors = $.domainBulkValidatePurchase(form);

              // hide/show errors
              $.bulkOpShowErrors(form, errors, form.find('.modal-footer>div>div'));

              if(errors.length > 0) {
                button.buttonLoading('reset');

                return false;
              }

              bulkRenewSubmitting = true;

              // submit form
              var url      = Storage.getData('app_url') + 'domain/bulk-renew/submit';
              var postData = $(this).serialize();

              $.post(url, postData, function (response) {
                bulkRenewSubmitting = false;
                button.buttonLoading('reset');

                if (0 == response.status && undefined != response.premiumDomains) {
                  // show warning about new price
                  $.bulkOpShowWarnings(form, [{message: response.message}], form.find('.modal-footer>div>div'));

                  // update form
                  $('#domain-purchase-is-premium').val(1);

                  // update prices
                  $.each(response.premiumDomains, function(key, value) {
                    var domain = form.find('[name="domains[{0}]"]'.format(key));

                    for (var year in value) {
                      domain.attr('data-price-{0}'.format(year), value[year])
                    }
                  });

                  $.bulkOpUpdatePrice(form, years, domains);
                } else if (
                  undefined !== response.format
                  && undefined !== response.type
                  && 'popin' === response.format
                  && 'pendingRenew'  === response.type
                ) {
                  if (0 !== $('#domain-renew-confirm-pending-bulk').length) {
                    $('#domain-renew-confirm-pending-bulk').modal('show');
                  } else {
                    $(response.msg).modal('show');
                  }
                } else {
                  // show error message
                  if (0 == response.status && undefined != response.message) {
                    $.bulkOpShowErrors(form, [{message: response.message}], form.find('.modal-footer>div>div'));
                  }

                  // do redirect
                  if(0 == response.status && undefined != response.page) {
                    window.location = Storage.getData('app_url') + response.page;
                  }
                }

                // all is ok
                if (response.status == 1) {
                  $.fancybox.close();
                  $.bulkClearSelectedDomains();

                  if(undefined != response.message && undefined != response.message.text && undefined != response.message.title) {
                    $.showSuccess(response.message.title, response.message.text);
                  }
                }
              }).fail(function () {
                bulkRenewSubmitting = false;
                button.buttonLoading('reset');
              });

              return false;
            });
          }
        });
      });

      e.preventDefault();
    });

    // bulk op update price
    $.bulkOpUpdatePrice = function(form, years, domains, coupon) {
      $.bulkUpdateYearlyPrices();


      var years          = years.filter(':checked'),
          domains        = domains.filter(':checked'),
          price          = form.find('#domain-bulk-op-total-prise'),
          paymentSection = $('#renew-domain-bulk-op-payment-section'),
          couponError    = form.find('#cpn-error'),
          couponMessage  = form.find('#cpnDis'),
          checkCoupon    = form.find('#checkCoupon'),
          couponInput    = $('#couponCode');

      // set default price
      if(0 == years.length || 0 == domains.length) {
        price.html('0.00');

        return;
      }

      // calculate price
      var totalYears = parseInt(years.val()),
          total      = 0
      ;

      $.each(domains, function() {
        var
            domainPrice = 0
        ;

        for (var i = 1; i < totalYears + 1; i++) {
          var yearPrice = $(this).attr('data-price-{0}'.format(i));

          if (undefined !== yearPrice) {
            domainPrice += parseFloat(yearPrice);
          }
        }

        total += domainPrice;
      });

      price.html(Number(total).toFixed(2));

      // coupon feature
      // no coupon defined - hide discount messages
      if(typeof undefined == typeof coupon) {
        couponError.addClass('hidden');
        couponMessage.addClass('hidden');
        paymentSection.removeClass('hidden');
        couponInput.val('');
        checkCoupon.prop('disabled', true);
      } else if (coupon <= 0) {
        // wrong response or wrong coupon - show error message
        couponError.removeClass('hidden');
        couponMessage.addClass('hidden');
        paymentSection.removeClass('hidden')
      } else {
        // all is ok
        couponError.addClass('hidden');
        couponMessage.removeClass('hidden');

        // calculate discount
        var afterCoupon = total - coupon;

        afterCoupon <= 0 ? paymentSection.addClass('hidden') : paymentSection.removeClass('hidden');
        form.find('#cpnDis .amount').html(total);
        form.find('#cpnDis .sum').html(afterCoupon >= 0 ? Number(afterCoupon).toFixed(2) : 0);
      }
    };

    $.bulkUpdateYearlyPrices = function(){
      var form           = $('#renew-domain-bulk-op'),
          periods          = form.find('input[type="radio"]'),
          domains        = form.find('#bulk-op-domains-list input[type="checkbox"]').filter(':checked'),
          total = 0.0;

      const periodValues = Array.from(periods).map(radio => parseInt(radio.value)).sort((a, b) => a - b);

      periodValues.forEach(period => {
        //loop all selected domains
        $.each(domains, function() {
          var yearPrice = $(this).attr(`data-price-${period}`);

          if (undefined !== yearPrice) {
            total += parseFloat(yearPrice);
          }
        });

        $(`#price-total-year${period}`).html(Number(total).toFixed(2));
        $(`#price-per-year-year${period}`).html(Number(total/period).toFixed(2));
      })
    }

    /**
     * Update bulk domains storage.
     */
    $.bulkStorageDomainsUpdate = function() {
      var storage     = $.localStorage,
          checked     = $('.domain-bulk-op-item:checked'),
          unchecked   = $('.domain-bulk-op-item:not(:checked)'),
          data        = storage.isSet('domains_bulk') ? storage.get('domains_bulk') : [];

      // add checked domains
      $.each(checked, function() {
        var id = $(this).data('domain');

        if(-1 == jQuery.inArray(id, data)) {
          data.push(id);
        }
      });

      // remove unchecked
      $.each(unchecked, function() {
        var id = $(this).data('domain');

        if(-1 != jQuery.inArray(id, data)) {
          var index = data.indexOf(id);
          data.splice(index, 1);
        }
      });

      // update storage
      storage.set('domains_bulk', data);

      // update control block
      $.bulkStorageUpdateControl();
    };

    /**
     * Show errors
     * todo@alexbuturlakin: need to remove this method after validation will be refactored.
     *
     * @param {jQuery} form
     * @param {[]}     errors
     * @param {jQuery} el
     */
    $.bulkOpShowErrors = function(form, errors, el) {
      var messages = [];

      // clear errors
      form.find('.has-error').removeClass('has-error');
      form.find('.alert-danger').remove();

      $.each(errors, function(k, v) {
        if(undefined != v['el']) {
          $(v['el']).parent().addClass('has-error');
        }

        messages.push(v['message']);
      });

      if(messages.length > 0) {
        el.showAlert(messages.join('<br/>'), 'danger');
      }
    };

    /**
     * Show errors
     * todo@alexbuturlakin: need to remove this method after validation will be refactored.
     *
     * @param {jQuery} form
     * @param {[]}     errors
     * @param {jQuery} el
     */
    $.bulkOpShowWarnings = function(form, errors, el) {
      var messages = [];

      // clear warnings
      form.find('.alert-warning').remove();

      $.each(errors, function(k, v) {
        if(undefined != v['el']) {
          $(v['el']).parent().addClass('has-error');
        }

        messages.push(v['message']);
      });

      if(messages.length > 0) {
        el.showAlert(messages.join('<br/>'), 'warning');
      }
    };

    // validate card
    // todo@alexbuturlakin: this is hardcode from domain renew. Need to refactor and use plugin for validation.
    $.domainBulkValidatePurchase = function (form) {
      var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
      var creditCardEl = form.find('#creditNumber');
      var creditYrEl = form.find('#creditExpirationYear');
      var creditMoEl = form.find('#creditExpirationMonth');
      var creditCardCvvEl = form.find('#creditCvv');
      var creditIdEl = form.find('#creditId');
      var domainPeriodEl = form.find('#domainPeriod');
      var date = new Date();
      var creditCard = creditCardEl.val();
      var creditCardYr = creditYrEl.val();
      var creditCardMo = creditMoEl.val();
      var creditCardCvv = creditCardCvvEl.val();
      var creditCardId = creditIdEl.val();
      var domainPeriod = parseInt(form.find('[name=domainPeriod]:checked').val());
      var approve_termsEl = form.find('#approve_terms');
      var approve_terms = approve_termsEl.is(":checked");
      var errors = [];

      var addError = function(el, message) {
        errors.push({el: el, message: message});
      };

      if(approve_terms != undefined) {
        if (!approve_terms) {
          addError(approve_termsEl, $.translate('Approve Terms is required'));
        }
      }

      if(false == form.find('#renew-domain-bulk-op-payment-section').hasClass('hidden')) {
        if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
          addError(creditYrEl, $.translate('Expiry Year is invalid'));
        }

        if (isNaN(creditCardMo) || creditCardYr == date.getFullYear() && creditCardMo < date.getMonth()) {
          addError(creditMoEl, $.translate('Expiry Month is invalid'));
        }

        if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
          addError(creditCardCvvEl, $.translate('cvv is invalid'));
        }

        if (isNaN(creditCardId) || creditCardId.length < 9 || creditCardId.length > 9) {
          addError(creditIdEl, $.translate('id is invalid'));
        }

        if (isNaN(creditCard) || creditCard.length < 9 || creditCard.length > 17 || !creditReg.test(creditCard) && creditCard.length > 9 || creditCard[0] === 0) {
          addError(creditCardEl, $.translate('card is invalid'));
        }
      }

      if (domainPeriod < 1 && domainPeriod > 5) {
        addError(domainPeriodEl, $.translate('Domain Period is invalid'));
      }
      return errors;
    };

    $(document).on('click', '#domain-renew-confirm-bulk-confirm', function() {
      $('#domain-renew-confirm-pending-bulk').modal('hide');
      $('#domain-renew-pending-confirmed').val(1);
      $('#renew').trigger('click');
    });

    $(document).on('click', '#domain-renew-confirm-bulk-cancel', function() {
      $('#domain-renew-confirm-pending-bulk').modal('hide');
    });

  });
})(jQuery);
